// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   Performance équipe - tableau de bord
   Aligné sur la charte CB-Connect (variables.css)
   ============================================================ */

/* Chiffres en colonnes : alignement comptable des métriques */
.perf-num {
  font-variant-numeric: tabular-nums;
  font-feature-settings: "tnum";
  font-family: ui-monospace, "SFMono-Regular", "DM Mono", Menlo, monospace;
}

/* Eyebrow : libellé structurel discret */
.perf-eyebrow {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.8px;
  text-transform: uppercase;
  color: var(--cb-text-muted);
}

/* ── Barre d'outils (filtres / actions) ───────────────────── */
.perf-toolbar {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
  margin-bottom: 16px;
}

.perf-toolbar__spacer {
  flex: 1 1 auto;
}

/* ── Anneau de score (élément signature) ──────────────────── */
.perf-ring {
  position: relative;
  flex: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}

.perf-ring__inner {
  position: absolute;
  inset: 4px;
  background: var(--cb-card);
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.perf-ring__val {
  font-weight: 800;
  line-height: 1;
}

.perf-ring__cap {
  font-size: 8px;
  font-weight: 700;
  letter-spacing: 0.5px;
  color: var(--cb-text-light);
}

/* ── Carte employé (vue équipe) ───────────────────────────── */
.perf-emp {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: var(--cb-card);
  border: 1px solid var(--cb-border);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-sm);
  padding: 20px;
  cursor: pointer;
  text-align: left;
  width: 100%;
  font: inherit;
  transition: box-shadow var(--tr-base), transform var(--tr-base), border-color var(--tr-base);
}

.perf-emp:hover {
  box-shadow: var(--shadow-md);
  transform: translateY(-2px);
  border-color: var(--cb-green);
}

.perf-emp:focus-visible {
  outline: 2px solid var(--cb-green);
  outline-offset: 2px;
}

.perf-avatar {
  flex: none;
  width: 46px;
  height: 46px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-weight: 700;
  font-size: 15px;
}

/* Bande de statistiques inline (sans encadrés) */
.perf-stats {
  display: flex;
  align-items: center;
  margin: 16px 0 14px;
}

.perf-stats > div {
  flex: 1 1;
  text-align: center;
}

.perf-stats > div + div {
  border-left: 1px solid var(--cb-border-light);
}

.perf-stat__v {
  font-size: 18px;
  font-weight: 700;
  color: var(--cb-text);
  line-height: 1.1;
}

.perf-stat__l {
  font-size: 10px;
  letter-spacing: 0.3px;
  color: var(--cb-text-muted);
  margin-top: 2px;
}

/* Barre de progression maison (sans dépendance) */
.perf-bar__head {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  font-size: 11.5px;
  margin-bottom: 4px;
}

.perf-bar__head .lbl {
  color: var(--cb-text-sec);
  font-weight: 500;
}

.perf-bar__head .val {
  color: var(--cb-text);
  font-weight: 700;
}

.perf-track {
  height: 6px;
  border-radius: 6px;
  background: var(--cb-border-light);
  overflow: hidden;
}

.perf-track__fill {
  height: 100%;
  border-radius: 6px;
  transition: width var(--tr-slow);
}

/* ── Badge de rang (classement, sans emoji) ───────────────── */
.perf-rank {
  width: 30px;
  height: 30px;
  border-radius: 9px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  font-size: 13px;
}

/* ── Graphe d'évolution (barres CSS) ──────────────────────── */
.perf-evo {
  display: flex;
  align-items: flex-end;
  gap: 10px;
  height: 170px;
  padding-bottom: 26px;
}

.perf-evo__col {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}

.perf-evo__bars {
  display: flex;
  align-items: flex-end;
  gap: 3px;
  height: 130px;
}

.perf-evo__bar {
  width: 13px;
  border-radius: 3px 3px 0 0;
  transition: height var(--tr-slow);
}

.perf-evo__lbl {
  position: absolute;
  bottom: -22px;
  font-size: 10px;
  color: var(--cb-text-muted);
}

.perf-evo__legend {
  display: flex;
  gap: 18px;
  justify-content: center;
  margin-top: 10px;
  font-size: 11px;
  color: var(--cb-text-muted);
}

.perf-evo__dot {
  display: inline-block;
  width: 9px;
  height: 9px;
  border-radius: 2px;
  margin-right: 5px;
  vertical-align: middle;
}

/* ── Ligne benchmark (détail : employé vs repère équipe) ──── */
.perf-bm {
  padding: 11px 0;
  border-bottom: 1px dashed var(--cb-border);
}

.perf-bm:last-child {
  border-bottom: none;
}

.perf-bm__top {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  margin-bottom: 7px;
}

.perf-bm__lbl {
  font-size: 13px;
  color: var(--cb-text-sec);
}

.perf-bm__val {
  font-size: 14px;
  font-weight: 700;
  color: var(--cb-text);
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.perf-bm__bar {
  position: relative;
  height: 8px;
  border-radius: 6px;
  background: var(--cb-border-light);
}

.perf-bm__fill {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  border-radius: 6px;
  transition: width var(--tr-slow);
}

.perf-bm__marker {
  position: absolute;
  top: -3px;
  bottom: -3px;
  width: 2px;
  border-radius: 2px;
  background: var(--cb-text-sec);
  transform: translateX(-1px);
}

.perf-bm__cap {
  margin-top: 5px;
  font-size: 11px;
  color: var(--cb-text-muted);
  text-align: right;
}

/* ── Ligne de comparaison (détail) ────────────────────────── */
.perf-cmp {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 9px 0;
  border-bottom: 1px dashed var(--cb-border);
}

.perf-cmp:last-child {
  border-bottom: none;
}

.perf-cmp__lbl {
  font-size: 13px;
  color: var(--cb-text-sec);
}

.perf-cmp__val {
  font-size: 14px;
  font-weight: 700;
  color: var(--cb-text);
}

.perf-cmp__avg {
  font-size: 11px;
  color: var(--cb-text-muted);
}

@media (prefers-reduced-motion: reduce) {

  .perf-emp,
  .perf-track__fill,
  .perf-evo__bar {
    transition: none;
  }

  .perf-emp:hover {
    transform: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/performance/performance.css"],"names":[],"mappings":"AAAA;;;iEAGiE;;AAEjE,8DAA8D;AAC9D;EACE,kCAAkC;EAClC,6BAA6B;EAC7B,wEAAwE;AAC1E;;AAEA,yCAAyC;AACzC;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA,gEAAgE;AAChE;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA,gEAAgE;AAChE;EACE,kBAAkB;EAClB,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,0BAA0B;EAC1B,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA,gEAAgE;AAChE;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,0BAA0B;EAC1B,kCAAkC;EAClC,+BAA+B;EAC/B,4BAA4B;EAC5B,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,4FAA4F;AAC9F;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA,iDAAiD;AACjD;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA,kDAAkD;AAClD;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA,gEAAgE;AAChE;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,gEAAgE;AAChE;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA,gEAAgE;AAChE;EACE,eAAe;EACf,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,SAAS;EACT,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,eAAe;EACf,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA,gEAAgE;AAChE;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA;;EAEE;;;IAGE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* ============================================================\n   Performance équipe - tableau de bord\n   Aligné sur la charte CB-Connect (variables.css)\n   ============================================================ */\n\n/* Chiffres en colonnes : alignement comptable des métriques */\n.perf-num {\n  font-variant-numeric: tabular-nums;\n  font-feature-settings: \"tnum\";\n  font-family: ui-monospace, \"SFMono-Regular\", \"DM Mono\", Menlo, monospace;\n}\n\n/* Eyebrow : libellé structurel discret */\n.perf-eyebrow {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.8px;\n  text-transform: uppercase;\n  color: var(--cb-text-muted);\n}\n\n/* ── Barre d'outils (filtres / actions) ───────────────────── */\n.perf-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  align-items: center;\n  margin-bottom: 16px;\n}\n\n.perf-toolbar__spacer {\n  flex: 1 1 auto;\n}\n\n/* ── Anneau de score (élément signature) ──────────────────── */\n.perf-ring {\n  position: relative;\n  flex: none;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n}\n\n.perf-ring__inner {\n  position: absolute;\n  inset: 4px;\n  background: var(--cb-card);\n  border-radius: 50%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.perf-ring__val {\n  font-weight: 800;\n  line-height: 1;\n}\n\n.perf-ring__cap {\n  font-size: 8px;\n  font-weight: 700;\n  letter-spacing: 0.5px;\n  color: var(--cb-text-light);\n}\n\n/* ── Carte employé (vue équipe) ───────────────────────────── */\n.perf-emp {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  background: var(--cb-card);\n  border: 1px solid var(--cb-border);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-sm);\n  padding: 20px;\n  cursor: pointer;\n  text-align: left;\n  width: 100%;\n  font: inherit;\n  transition: box-shadow var(--tr-base), transform var(--tr-base), border-color var(--tr-base);\n}\n\n.perf-emp:hover {\n  box-shadow: var(--shadow-md);\n  transform: translateY(-2px);\n  border-color: var(--cb-green);\n}\n\n.perf-emp:focus-visible {\n  outline: 2px solid var(--cb-green);\n  outline-offset: 2px;\n}\n\n.perf-avatar {\n  flex: none;\n  width: 46px;\n  height: 46px;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n  font-weight: 700;\n  font-size: 15px;\n}\n\n/* Bande de statistiques inline (sans encadrés) */\n.perf-stats {\n  display: flex;\n  align-items: center;\n  margin: 16px 0 14px;\n}\n\n.perf-stats > div {\n  flex: 1;\n  text-align: center;\n}\n\n.perf-stats > div + div {\n  border-left: 1px solid var(--cb-border-light);\n}\n\n.perf-stat__v {\n  font-size: 18px;\n  font-weight: 700;\n  color: var(--cb-text);\n  line-height: 1.1;\n}\n\n.perf-stat__l {\n  font-size: 10px;\n  letter-spacing: 0.3px;\n  color: var(--cb-text-muted);\n  margin-top: 2px;\n}\n\n/* Barre de progression maison (sans dépendance) */\n.perf-bar__head {\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n  font-size: 11.5px;\n  margin-bottom: 4px;\n}\n\n.perf-bar__head .lbl {\n  color: var(--cb-text-sec);\n  font-weight: 500;\n}\n\n.perf-bar__head .val {\n  color: var(--cb-text);\n  font-weight: 700;\n}\n\n.perf-track {\n  height: 6px;\n  border-radius: 6px;\n  background: var(--cb-border-light);\n  overflow: hidden;\n}\n\n.perf-track__fill {\n  height: 100%;\n  border-radius: 6px;\n  transition: width var(--tr-slow);\n}\n\n/* ── Badge de rang (classement, sans emoji) ───────────────── */\n.perf-rank {\n  width: 30px;\n  height: 30px;\n  border-radius: 9px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 800;\n  font-size: 13px;\n}\n\n/* ── Graphe d'évolution (barres CSS) ──────────────────────── */\n.perf-evo {\n  display: flex;\n  align-items: flex-end;\n  gap: 10px;\n  height: 170px;\n  padding-bottom: 26px;\n}\n\n.perf-evo__col {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  position: relative;\n}\n\n.perf-evo__bars {\n  display: flex;\n  align-items: flex-end;\n  gap: 3px;\n  height: 130px;\n}\n\n.perf-evo__bar {\n  width: 13px;\n  border-radius: 3px 3px 0 0;\n  transition: height var(--tr-slow);\n}\n\n.perf-evo__lbl {\n  position: absolute;\n  bottom: -22px;\n  font-size: 10px;\n  color: var(--cb-text-muted);\n}\n\n.perf-evo__legend {\n  display: flex;\n  gap: 18px;\n  justify-content: center;\n  margin-top: 10px;\n  font-size: 11px;\n  color: var(--cb-text-muted);\n}\n\n.perf-evo__dot {\n  display: inline-block;\n  width: 9px;\n  height: 9px;\n  border-radius: 2px;\n  margin-right: 5px;\n  vertical-align: middle;\n}\n\n/* ── Ligne benchmark (détail : employé vs repère équipe) ──── */\n.perf-bm {\n  padding: 11px 0;\n  border-bottom: 1px dashed var(--cb-border);\n}\n\n.perf-bm:last-child {\n  border-bottom: none;\n}\n\n.perf-bm__top {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  margin-bottom: 7px;\n}\n\n.perf-bm__lbl {\n  font-size: 13px;\n  color: var(--cb-text-sec);\n}\n\n.perf-bm__val {\n  font-size: 14px;\n  font-weight: 700;\n  color: var(--cb-text);\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.perf-bm__bar {\n  position: relative;\n  height: 8px;\n  border-radius: 6px;\n  background: var(--cb-border-light);\n}\n\n.perf-bm__fill {\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  border-radius: 6px;\n  transition: width var(--tr-slow);\n}\n\n.perf-bm__marker {\n  position: absolute;\n  top: -3px;\n  bottom: -3px;\n  width: 2px;\n  border-radius: 2px;\n  background: var(--cb-text-sec);\n  transform: translateX(-1px);\n}\n\n.perf-bm__cap {\n  margin-top: 5px;\n  font-size: 11px;\n  color: var(--cb-text-muted);\n  text-align: right;\n}\n\n/* ── Ligne de comparaison (détail) ────────────────────────── */\n.perf-cmp {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 9px 0;\n  border-bottom: 1px dashed var(--cb-border);\n}\n\n.perf-cmp:last-child {\n  border-bottom: none;\n}\n\n.perf-cmp__lbl {\n  font-size: 13px;\n  color: var(--cb-text-sec);\n}\n\n.perf-cmp__val {\n  font-size: 14px;\n  font-weight: 700;\n  color: var(--cb-text);\n}\n\n.perf-cmp__avg {\n  font-size: 11px;\n  color: var(--cb-text-muted);\n}\n\n@media (prefers-reduced-motion: reduce) {\n\n  .perf-emp,\n  .perf-track__fill,\n  .perf-evo__bar {\n    transition: none;\n  }\n\n  .perf-emp:hover {\n    transform: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
